import { combineReducers } from "redux";

import { IApplicationState } from "./application-state";
import { userReducer, authReducer, dsDashboardReducer } from "app/states/ducks";

const rootReducer: any = combineReducers<IApplicationState>({
    auth: authReducer,
    user: userReducer,
    dsDashboard: dsDashboardReducer
});

export default rootReducer;
